export default __webpack_public_path__ + "media/images/apartment_page/premium_line_towels-7394eff2e217083c3c180b2a7f4c9b9e.jpg";